import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section className='py-32 bg-gray-50 dark:bg-gray-900 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='text-5xl font-montserrat font-bold bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent mb-6'>
          Политика конфиденциальности
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          Узнайте, как мы защищаем вашу личную информацию.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='bg-white dark:bg-gray-800/70 p-6 rounded-2xl shadow-md'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Сбор данных</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Информация о том, какие данные мы собираем.
            </p>
          </div>
          <div className='bg-white dark:bg-gray-800/70 p-6 rounded-2xl shadow-md'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Использование данных</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Как мы используем ваши данные для улучшения услуг.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
